export default {
	"bff92461c5b7ce465bbc65ad23ae30bd": "进行在线付款",
	"4da7dfaeaef3949bdd1f8f0b6d3f2701": "点击屏幕右上角",
	"2cc04bdc4e54ce88088307f6632c733c": "，选择浏览器打开本页"
}
